import { GenericFailure } from '@playq/services-shared';

import { getErrorMessage } from '/helpers/getErrorMessage';

export function throwGenericFailure(e: GenericFailure) {
  throw new Error(getErrorMessage(e));
}
